import { CustomFieldAddModel } from "./CustomFieldAddModel";

export class CustomFieldEditModel extends CustomFieldAddModel{

}
